export const successAction = (action: string) => `${action}/success`;
export const failAction = (action: string) => `${action}/fail`;
